import StaticIdSingletonClass from './static-id';

/**
 * Enable console log based on the debug flag.
 * @param {string} message
 * @param {data} data
 */
const LOGGER_STYLE = 'color: blue; font-weight: bold';
const logger = (message, data = '') => {
  if (StaticIdSingletonClass.debug) {
    //eslint-disable-next-line
    console.log(`%cVisa SRC System SDK -- ${message}`, LOGGER_STYLE, data);
  }
};

export default logger;
